// MegaMenu.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { buttonloginstyle } from "../help/Utils";
import MARKETING_SITE_URL from "../API/MARKETING_SITE_URL";
import { GrSend } from "react-icons/gr";
import { LuArrowRight } from "react-icons/lu";
const MegaMenu = ({ isOpen }) => {
  const [activeTab, setActiveTab] = useState("Families");
  if (!isOpen) return null;

  // Inline style for the keyframes (or place in your CSS file / Tailwind config)
  const slideDownStyle = `
    @keyframes slideDown {
      0% {
        transform: translateY(-20px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
    .animate-slideDown {
      animation: slideDown 0.3s ease-out forwards;
    }
  `;

  return (
    <div
      className="
     absolute top-full left-1/2 transform -translate-x-1/2  megamenu_w bg-white p-6 z-50 rounded-2xl shadow-2xl
      "
    >
      <style>{slideDownStyle}</style>

      <h1 className=" mb-2 heading-lg">Visa Services</h1>
      <p className="pera mb-6">
        Discover the right visa pathway — simplified for families,
        professionals, and investors.
      </p>

      {/* Tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="flex space-x-6">
          <button
            onClick={() => setActiveTab("Families")}
            className={`pb-2 text-lg font-medium ${
              activeTab === "Families"
                ? "border-b-2 border-[#1B365D] text-[#1B365D] font-bold"
                : "text-[#9CA3AF] hover:text-[#1B365D] hover:border-[#1B365D]"
            }`}
          >
            For Individual & Families
          </button>
          <button
            onClick={() => setActiveTab("Business")}
            className={`pb-2 text-lg font-medium ${
              activeTab === "Business"
                ? "border-b-2 border-[#1B365D] text-[#1B365D] font-bold"
                : "text-[#9CA3AF] hover:text-[#1B365D] hover:border-[#1B365D]"
            }`}
          >
            Business
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      <div className="">
        {activeTab === "Families" && (
          <>
            <div className="flex justify-between">
              <div class="menu_box yellow-bg">
                <h5 class="mb-4 d-md-block d-none">
                  Individuals &amp; Families
                </h5>
                <div class="grid grid-cols-2 md:grid-cols-2  justify-content-center">
                  <div class="">
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/application-for-naturalization/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon orange-bg">N-400</div>
                        <div class="mega_text">
                          N-400 - Citizenship Application
                        </div>
                      </div>
                    </a>
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/green-card-renewal-replacement/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon orange-bg">I-90</div>
                        <div class="mega_text">
                          I-90 - Green Card Renewal/Replacement
                        </div>
                      </div>
                    </a>
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/green-card-conditions-removal/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon orange-bg">I-751</div>
                        <div class="mega_text">
                          I-751 - Green Card Conditions Removal
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="">
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/petition-for-alien-relative/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon orange-bg">I-130</div>
                        <div class="mega_text">I-130 - Family Sponsorship</div>
                      </div>
                    </a>
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/travel-document-application/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon orange-bg">I-131</div>
                        <div class="mega_text">
                          I-131 - Travel Document Application
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="mega_menu_right position-relative"
                style={{
                  backgroundImage:
                    `url('${MARKETING_SITE_URL}/wp-content/uploads/2025/07/services-banner.jpg')`,
                }}
              >
                <div>
                  <img
                    src={`${MARKETING_SITE_URL}/wp-content/themes/letsgetvisa/assets/images/calendar-clock.png`}
                    alt="calendar clock"
                  />
                  <h3 class="heading-lg text-light mt-3 text-white">
                    New pathways launching soon
                  </h3>
                </div>
              <button
                                className="flex items-center md:w-auto w-fill justify-center mt-5"
                                style={buttonloginstyle}
                              >
                               Remind Me &nbsp;  <LuArrowRight  />
                              </button>
              </div>
            </div>
          </>
        )}

        {activeTab === "Business" && (
          <>
            <div className="flex justify-between">
              <div class="menu_box yellow-bg">
                <h5 class="mb-4 d-md-block d-none">Businesses</h5>
                <div class="grid grid-cols-2 md:grid-cols-2  justify-content-center">
                  <div class="">
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/h-1b/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon green-bg">H-1B</div>
                        <div class="mega_text">
                          H-1B - Temporary Skilled Worker Visa
                        </div>
                      </div>
                    </a>
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/student-visa/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon green-bg">F-1</div>
                        <div class="mega_text">F-1 - Student Visa</div>
                      </div>
                    </a>
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/application-for-employment-authorization/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon green-bg">I-765</div>
                        <div class="mega_text">
                          I-765 - Application for Employment Authorization
                        </div>
                      </div>
                    </a>
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/business-tourism-visas/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon green-bg">B-1/B-2</div>
                        <div class="mega_text">
                          B-1/B-2 - Business &amp; Tourism Visas
                        </div>
                      </div>
                    </a>
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/intra-company-transfer-visa/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon green-bg">L-1</div>
                        <div class="mega_text">
                          L-1 - Intra-Company Transfer Visa
                        </div>
                      </div>
                    </a>
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/exchange-visa/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon green-bg">J-1</div>
                        <div class="mega_text">J-1 - Exchange Visitor Visa</div>
                      </div>
                    </a>
                  </div>
                  <div class="">
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/employment-based-first-preference/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon green-bg">EB-1</div>
                        <div class="mega_text">
                          EB-1 - Employment-Based First Preference
                        </div>
                      </div>
                    </a>
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/niw-employment-based-second-preference/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon green-bg"> EB-2</div>
                        <div class="mega_text">
                          {" "}
                          EB-2 - Employment-Based Second Preference
                        </div>
                      </div>
                    </a>
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/employment-based-third-preference/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon green-bg">EB-3</div>
                        <div class="mega_text">
                          EB-3 - Employment-Based Third Preference
                        </div>
                      </div>
                    </a>
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/temporary-skilled-worker-visa/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon green-bg">EB-4</div>
                        <div class="mega_text">
                          EB-4 - Employment-Based Immigration
                        </div>
                      </div>
                    </a>
                    <a
                      class="block"
                      href={`${MARKETING_SITE_URL}/services/investor-visa/`}
                    >
                      <div class="flex items-center megamenu_box">
                        <div class="menu_icon green-bg">EB-5</div>
                        <div class="mega_text">EB-5 - Investor Visa</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="mega_menu_right position-relative"
                style={{
                  backgroundImage:
                    `url('${MARKETING_SITE_URL}/wp-content/uploads/2025/08/image.png')`,
                }}
              >
                <div>
                  <img
                    src={`${MARKETING_SITE_URL}/wp-content/themes/letsgetvisa/assets/images/calendar-clock.png`}
                    alt="calendar clock"
                  />
                  <h3 class="heading-lg text-white mt-3">
                    Unlimited revisions on your application until submission
                  </h3>
                </div>
                <button
                                className="flex items-center md:w-auto w-fill justify-center"
                                style={buttonloginstyle}
                              >
                               Remind Me &nbsp;  <LuArrowRight  />
                              </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MegaMenu;
